/**
 * DBE Keeper 패턴 — 디바이스 자동 잠금해제 API 래퍼 (Issue #1291).
 *
 * 백엔드 endpoint 6개를 safeboxClient (Authorization: JWT 자동) 호출로 매핑.
 * 응답 패턴: {code, message, data} — code===200이면 정상. 에러 해석(코드별 분기)은
 * 호출 측(LoginMasterPW 자동 잠금해제 / PasskeyManagement 등록)에서 수행한다
 * (passkey/api.js 와 동일 thin-래퍼 패턴 — index.js 가 PasskeyApiError 로 해석).
 *
 * 백엔드 계약 (routers/v1/auth_device.py, api/model/auth_device.py):
 *   POST   /v1/auth/device/register-options  body 없음           → data { challenge_id, options }
 *   POST   /v1/auth/device/register          body register       → data { device_id, created_at }
 *   POST   /v1/auth/device/unlock-options    { device_id }       → data { challenge_id, options }
 *   POST   /v1/auth/device/unlock            { device_id, challenge_id, credential_response }
 *                                                                 → data { wrapped_vault_key, iv }
 *   DELETE /v1/auth/device/current           { device_id }       → data 없음
 *   PATCH  /v1/auth/device/current/label     { device_id, device_label } → data { device_id, device_label }
 */
import { safeboxClient } from 'myNet'

// POST /v1/auth/device/register-options — 기존 패스키 challenge 발급 (본인 재확인)
export async function fetchDeviceRegisterOptions() {
  const res = await safeboxClient.post('/v1/auth/device/register-options', {})
  return res.data
}

// POST /v1/auth/device/register — self-ECDH 공개키 + wrapped_vault_key 저장
export async function postDeviceRegister(body) {
  // body: { challenge_id, credential_response, client_pub_jwk, wrapped_vault_key, iv, device_label, user_agent }
  const res = await safeboxClient.post('/v1/auth/device/register', body)
  return res.data
}

// POST /v1/auth/device/unlock-options — device_id 기준 잠금해제 challenge 발급
export async function fetchDeviceUnlockOptions(deviceId) {
  const res = await safeboxClient.post('/v1/auth/device/unlock-options', { device_id: deviceId })
  return res.data
}

// POST /v1/auth/device/unlock — assertion 검증 후 wrapped_vault_key 반환
export async function postDeviceUnlock(body) {
  // body: { device_id, challenge_id, credential_response }
  const res = await safeboxClient.post('/v1/auth/device/unlock', body)
  return res.data
}

// DELETE /v1/auth/device/current — 현재 디바이스 등록 해제
export async function deleteCurrentDevice(deviceId) {
  const res = await safeboxClient.delete('/v1/auth/device/current', { device_id: deviceId })
  return res.data
}

// PATCH /v1/auth/device/current/label — 디바이스 라벨 수정
export async function patchDeviceLabel(deviceId, deviceLabel) {
  const res = await safeboxClient.patch('/v1/auth/device/current/label', {
    device_id: deviceId,
    device_label: deviceLabel,
  })
  return res.data
}
